import type { BadgeTone } from "@/components/ui/Badge";

export type IngestSource = "n8n_only" | "app_only";

/**
 * Owner column: operational meaning, not a raw copy of `source` when the row is off.
 * `source` in the database never goes away; `enabled` gates scheduled runs in this app.
 */
export function ingestOwnerBadge(source: IngestSource, enabled: boolean): { label: string; tone: BadgeTone; title: string } {
  if (!enabled) {
    return {
      label: "Off",
      tone: "warning",
      title:
        source === "app_only"
          ? "Scheduled ingests are paused. The stored owner is still app_only; enable and run the scheduler to resume."
          : "Control row is off. The stored owner is still n8n_only.",
    };
  }
  return {
    label: source,
    tone: source === "app_only" ? "info" : "muted",
    title:
      source === "app_only"
        ? "This app is configured to run live ingests on the cron schedule. Requires the scheduler process and an enabled row."
        : "n8n (or the legacy stack) is the active owner. This app does not run scheduled live ingests for this entity.",
  };
}
